import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { DataService } from './data.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const dataService = inject(DataService);
  const router = inject(Router);

  const currentUrl = state.url;

  // Check if the user is logged in
  const user = dataService.userValue;
  const employee = dataService.employeeValue;
  const token = dataService.tokenValue;
  // && (!employee || dataService.checkDomain())
  if (user && token) {
    // Redirect authenticated users trying to access auth routes
    if (currentUrl.includes('auth')) {
      // check query params for the logout key if it true then logout the user
      if (state.root.queryParams['logout'] === 'true') {
        //alert('auth.guard.ts');
        dataService.clear();
        router.navigate(['/']);
        return false;
      }
      router.navigate(['/']);
      return false;
    }

    // Force payment page if subscription status is Pending
    if (employee?.subscriptionStatus === 'Pending') {
      if (!currentUrl.startsWith('/payment')) {
        router.navigate(['/payment']);
        return false;
      }
      return true;
    } else if (employee) {
      if (currentUrl.startsWith('/payment')) {
        router.navigate(['/']);
        return false;
      }
    } else {
      // If employee is not loaded yet (during startup refresh), allow /payment route to resolve
      if (currentUrl.startsWith('/payment')) {
        return true;
      }
    }

    // Restrict startup employees (empType === 's') to the i-nest module only
    if (
      dataService.empTypeValue === 's' &&
      !currentUrl.startsWith('/i-nest') &&
      !currentUrl.includes('errors')
    ) {
      router.navigate(['/i-nest/attendance/self']);
      return false;
    }

    const requiredRoles = route.data?.['roles'] || [];
    const requiredRight: string | string[] = route.data?.['right'] || '';

    // Allow access if no specific roles, modules, or rights are required
    if (!requiredRoles.length && !requiredRight) {
      return true;
    }

    // Check role-based access
    if (requiredRoles.includes(dataService.roleValue)) {
      // Always allow for universal roles
      if (['customer', 'superadmin'].includes(dataService.roleValue)) {
        return true;
      }

      // For employees, check permissions if a module and right are specified
      if (
        dataService.roleValue === 'employee' &&
        dataService.hasPermission(requiredRight)
      ) {
        return true;
      }
    }

    // Redirect to "Not Authorized" if role or permission checks fail
    router.navigate(['errors/not-authorized']);
    return false;
  } else {
    //alert('auth.guard.ts-2');
    dataService.clear(!dataService.checkDomain());
  }

  // Redirect unauthenticated users trying to access protected routes
  if (!currentUrl.includes('auth')) {
    router.navigate(['/']);
    return false;
  }

  return true;
};
